import _extends from "@babel/runtime/helpers/extends";
import { createTheme } from '@uiw/codemirror-themes';
export var defaultSettingsConsoleDark = {
  background: '#000',
  foreground: '#fff',
  caret: '#fff',
  selection: '#5c6c9b',
  selectionMatch: '#2a3967',
  gutterBackground: '#000',
  gutterForeground: '#ada9a9',
  gutterActiveForeground: '#fff',
  lineHighlight: '#82828275'
};
export var consoleDarkInit = options => {
  var {
    theme = 'dark',
    settings = {},
    styles = []
  } = options || {};
  return createTheme({
    theme: theme,
    settings: _extends({}, defaultSettingsConsoleDark, settings),
    styles: [...styles]
  });
};
export var consoleDark = consoleDarkInit();